import { Button, Tooltip } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { AdminTransfer } from 'src/core/models'
import { EyeOutlined } from '@ant-design/icons'
import { DepositsDetailsModal } from 'src/components'

const TransferDetailsButton: React.FC<{ transfer: AdminTransfer }> = ({ transfer }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)

  return <>
    <Tooltip title={t('Transfer.Check')} color={'blue'}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        className={`radius-100`}
        onClick={() => setIsModalVisible(true)}
        icon={<EyeOutlined />}
      />
    </Tooltip>

    <DepositsDetailsModal
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
      deposit={{
        currency_token_id: transfer.order.currency_token,
        amount: transfer.order.total,
        internal_reference: transfer.order.reference
      }}
    />
  </>
}

export default TransferDetailsButton
